export const contentTableConfig = {
  title: '复播课程列表',
  propList: [
    { prop: 'name', label: '课程名称', minWidth: '120' },
    { prop: 'enName', label: '课程拼音缩写', minWidth: '80' },
    { prop: 'cover', label: '封面', minWidth: '80', slotName: 'cover' },
    {
      label: '操作',
      minWidth: '120',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
